/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CartaoSolicitarAliases {
  AUTOCOMPLETE_MOTIVOS = 'autocomplete-motivos',
  BUTTON_SOLICITAR = 'button-solicitar',
  CARD_0 = 'card-0',
  FETCH_0 = 'fetch-0',
  FETCH_DADOS = 'fetch-dados',
  FIELD_0 = 'field-0',
  FIELD_MENSAGEM = 'field-mensagem',
  FIELD_MENSAGEM2 = 'field-mensagem2',
  FIELD_TOAST = 'field-toast',
  FIELD_UPLOAD = 'field-upload',
  FILE_UPLOADER = 'file-uploader',
  FORM_SOLICITAR = 'form-solicitar',
  LAYOUT_CARTAO_SOLICITAR = 'layout-cartao-solicitar',
  LOADER_0 = 'loader-0',
  LOADER_1 = 'loader-1',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_BUTTON = 'panel-button',
  PANEL_LOADER = 'panel-loader',
  PANEL_LOADER_1 = 'panel-loader-1',
  PANEL_SOLIC_CARTAO = 'panel-solic-cartao',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_MENSAGEM = 'text-mensagem',
  TEXT_MENSAGEM2 = 'text-mensagem2',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { CartaoSolicitarAliases };
